import { IStore } from "..";
import { TGraphConfigurationFilter, TGraphConfigurationReducerState } from "../../app/types/graph-configuration-types";

export const getFilters = (state: IStore): Partial<TGraphConfigurationFilter> => state.graphConfigurationReducer.filters;
export const getState = (state: IStore): TGraphConfigurationReducerState => state.graphConfigurationReducer;
